export default __webpack_public_path__ + "static/kindergarten-readiness7-37595339ff8f0fae162fa34fdfb116e0.jpg";